import {Grid, styled} from '@mui/material';

export const InfoText = styled(Grid)(({ theme }) => ({
    ...theme.palette.primary,
    paddingBottom: '1vh',
    paddingLeft: '0.5vh',
    fontSize: '23px',
}));
